export default __webpack_public_path__ + "static/media/nutrition.9e1b8e73.jpeg";